import { render, staticRenderFns } from "./TaskInfoModal.vue?vue&type=template&id=410d288a&scoped=true"
import script from "./TaskInfoModal.vue?vue&type=script&lang=js"
export * from "./TaskInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d288a",
  null
  
)

export default component.exports